import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { NewsletterBand } from "@/components/NewsletterBand";

export const Route = createFileRoute("/newsletter")({
  head: () => ({
    meta: [
      { title: "Newsletter - Smartasaurus" },
      { name: "description", content: "One discovery you'll tell someone about - every week, one strange, true thing from science, hand-picked by Smartasaurus. No filler. No spam." },
      { property: "og:title", content: "One discovery you'll tell someone about" },
      { property: "og:description", content: "Every week, one strange, true thing from science. The kind you repeat at dinner before you've finished chewing." },
      { property: "og:url", content: "https://smartasaurus.com/newsletter" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "One discovery you'll tell someone about" },
      { name: "twitter:description", content: "Every week, one strange, true thing from science. The kind you repeat at dinner before you've finished chewing." },
    ],
    links: [{ rel: "canonical", href: "https://smartasaurus.com/newsletter" }],
  }),
  component: NewsletterPage,
});

function NewsletterPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main id="main-content" className="pt-10">
        {/* Visually-hidden H1 keeps a single semantic top-level heading for SEO / a11y
            while the NewsletterBand keeps its designed h2 hero treatment. */}
        <h1 className="sr-only">Smartasaurus newsletter - one discovery that makes you sharper, every week</h1>
        <NewsletterBand />
      </main>
      <SiteFooter />
    </div>
  );
}
